import { IUser } from '@admin/types/user';

declare global {
  interface Window {
    clutter: {
      user: IUser & {
        notification_count: number;
        warehouse_task_count: number;
        admin_nav_favorites: string[];
        external_group: string;
      };
      flash?: Record<'info' | 'danger' | 'warning', string>;
      config: {
        google: {
          mapsApiKey: string;
        };
        pusher: {
          key: string;
          cluster: string;
          host?: string;
          port?: number;
        };
      };
      env: () => string;
    };
    REDUX_STATE?: unknown;
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof import('redux').compose;
  }
}

export const currentUser = window.clutter.user;
